import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Table } from 'antd';
import styled from 'styled-components';

import AppTemplate from '../../templates/AppTemplate';
import TableSearch from '../../atoms/TableSearch';

const StyledTable = styled(Table)`
  tbody {
    tr td:nth-child(1) {
      padding: 0;
    }
    td a {
      display: block;
      padding: 16px 16px;
    }
    tr {
      cursor: pointer;
    }
  }
`;

const ForecastList = ({
  loading,
  rejectedCampaign,
  forecastList,
  columns,
  history,
  handleSearchTable,
  showNewForecastModal,
  pagination,
  handleTableChange,
}) => (
  <AppTemplate>
    <h1>
      Forecast Listings{' '}
      <Button type="primary" size="large" onClick={showNewForecastModal}>
        New Forecast
      </Button>
    </h1>

    <Row type="flex" justify="end" align="middle">
      <Col span={4}>
        <TableSearch handleSearchTable={handleSearchTable} />
      </Col>
    </Row>

    <div className="tableContainer">
      <Row>
        <Col>
          <StyledTable
            onRow={record => ({
              onClick: () => history.push(`/forecasts/${record.id}/revision/${record.revision_id}`),
            })}
            pagination={pagination}
            rowKey="id"
            onChange={handleTableChange}
            loading={loading}
            dataSource={forecastList}
            columns={columns}
            locale={{ emptyText: 'No forecasts found.' }}
          />
        </Col>
      </Row>
    </div>
  </AppTemplate>
);

ForecastList.defaultProps = {
  loading: false,
};

ForecastList.propTypes = {
  loading: PropTypes.bool,
};

export default ForecastList;
